import { API_URL } from "config";
import Http from "util/https";
import { axiosDownloadFromUrl } from "../utils/common";

/**
 * axiosでエラーレポートをダウンロード
 * @param progressCallback ダウンロードの進捗を受け取るコールバック関数。引数はダウンロードの進捗率（0-100）。進捗率が不明な場合はnull。
 * @returns void
 */
export default async function downloadWeeklyReplenishmentErrorApi(progressCallback?: (percent: number | null) => void): Promise<void> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/weekly/csv/operation?operation=2`;
  const res = await http.get<{url: string}>(url, {});
  console.log(res);

  // const res: {data: {url: string}} = {data: {url: 'https://sample-videos.com/csv/Sample-Spreadsheet-10-rows.csv'}}; // 失敗テスト用のダミーデータ
  // const res: {data: {url: string}} = {data: {url: 'https://httpbin.org/range/1000?duration=10&chunk_size=128'}}; // 成功テスト用のダミーデータ
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)}); // ダウンロードの遅延をシミュレート
  await axiosDownloadFromUrl(res.data.url, '週次補充エラー', progressCallback);
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)}); // ダウンロードの遅延をシミュレート
}